import React from 'react';

export const StatusButton = ({ color }) => {
  return (
    <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: color, marginRight: '3px' }} />
  );
};
